import { render, staticRenderFns } from "./AccountUnsubscribe.vue?vue&type=template&id=180f6fa6&scoped=true&"
import script from "./AccountUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./AccountUnsubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f6fa6",
  null
  
)

export default component.exports